/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { Divider } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import DialogButton from '../../ui/utils/DialogButton';
import { deleteApp } from '../../ui/app/AppGraphQL';

function AppDeleteDialog(props) {
	const { open, machineId, machineName } = props;

	if (!open) {
		return null;
	}

	const handleSubmitDeleteMachine = async () => {
		try {
			await deleteApp(machineId);
			props.close();
		} catch (error) {
			props.close();
		}
	};

	const handleKeyPressed = (event) => {
		switch (event.key) {
			case 'Enter':
				return handleSubmitDeleteMachine();
			case 'Escape':
				return props.close();
			default:
		}
		return false;
	};

	return (
		<Dialog open={open} onClose={() => props.close()} onKeyDown={handleKeyPressed}>
			<DialogTitle>
				<FormattedMessage id="AppDeleteDialog.Title" defaultMessage="Delete Machine" />
			</DialogTitle>
			<DialogContent
				style={{
					margin: '20px'
				}}
			>
				<DialogContentText>
					<FormattedMessage
						id="AppDeleteDialog.Message"
						defaultMessage="This action can not be undone. Are you sure,
								you want to delete the machine: '{machine}'?"
						values={{ machine: machineName }}
					/>
				</DialogContentText>
			</DialogContent>
			<Divider />
			<DialogActions>
				<DialogButton margin defaultButton onClick={() => props.close()}>
					<FormattedMessage id="Cancel" defaultMessage="Cancel" />
				</DialogButton>
				<DialogButton margin onClick={handleSubmitDeleteMachine}>
					<FormattedMessage id="OK" defaultMessage="OK" />
				</DialogButton>
			</DialogActions>
		</Dialog>
	);
}

AppDeleteDialog.propTypes = {
	machineName: PropTypes.string,
	machineId: PropTypes.string,
};

AppDeleteDialog.defaultProps = {
	machineName: null,
	machineId: null
};





export default AppDeleteDialog;
